"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomatedLiveAuctionComponent = void 0;
var react_1 = __importDefault(require("react"));
var auction_details_1 = require("../../../../components/auction_details");
var countdown_1 = require("./countdown");
var lots_with_bids_1 = require("../../../../components/lots_with_bids");
var bidder_status_1 = require("../../../../components/bidder_status");
var AutomatedLiveAuctionComponent = function () {
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(countdown_1.CountdownComponent, null),
        react_1.default.createElement(auction_details_1.AuctionDetailsComponent, null),
        react_1.default.createElement(bidder_status_1.BidderStatusComponent, null),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(lots_with_bids_1.LotsWithBids, null))));
};
exports.AutomatedLiveAuctionComponent = AutomatedLiveAuctionComponent;
